import { datetimeToString } from "./datetime";

export function parseOccurences(occurrences){
  const parsedOccurrences = [];
  if(occurrences){
    for(let [key, value] of Object.entries(occurrences)){
      if(value){
        // if we dont want to handle it as UTC just change to
        parsedOccurrences.push({
          day: key,
          start_time: datetimeToString(value, 'HH:mm'),
          end_time: datetimeToString(value, 'HH:mm')
        })
      }
    }
    return parsedOccurrences;
  }else{
    return [];
  }     
}